module.exports = __webpack_public_path__ + "7d5cf746271bbe9fbccafda7d9f9cc25.MP3";